// SectionAccordion.tsx
import { ChevronDown } from 'lucide-react';
import { cn } from '../utils/cn';

export function SectionAccordion({ title, icon, open, toggle, sectionKey, children }) {
  return (
    <div className="border rounded-xl overflow-hidden bg-white shadow-lg">
      <button
        onClick={() => toggle(sectionKey)}
        className="w-full flex justify-between items-center px-4 py-6 text-left hover:bg-blue-50"
      >
        <div className="flex items-center gap-2 text-[#004060] font-semibold text-xl">
          {icon}
          {title}
        </div>
        <ChevronDown
          className={cn(
            'w-5 h-5 text-[#236caf] transition-transform duration-200',
            open && 'rotate-180'
          )}
        />
      </button>

      {open && (
        <div className="p-4 sm:p-6 space-y-4 text-med text-gray-800">
          {children}
        </div>
      )}
    </div>
  );
}